<template>
	<div
		:class="[
			'py-12 sm:py-16 bg-accented min-w-screen relative isolate overflow-hidden',
			dividerClass
		]"
	>
		<div class="px-4 md:px-12">
			<div class="max-w-3xl pt-4 mx-auto">
				<h2 class="pb-4 text-5xl flex flex-col tracking-tight text-center">
					<span class="text-primary font-semibold uppercase tracking-tight">
						{{ $t('faqs.title1') }}
					</span>
					<span class="text-highlighted font-medium tracking-tight">
						{{ $t('faqs.title2') }}
					</span>
				</h2>
				<div class="divide-y divide-elevated">
					<FaqsFaq
						v-for="faq in faqs"
						:key="faq.question"
						:faq="faq"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { FaqProps } from '@/types/components/faqs'
import type { ComponentProps } from '@/types/components/index'

const props = defineProps({
	faqs: {
		type: Object as PropType<FaqProps[]>,
		required: true
	},
	divider: {
		type: String as PropType<ComponentProps['divider']>,
		default: 'none'
	}
})

const { divider } = toRefs(props)

const dividerClass = computed(() => {
	switch (divider.value) {
		case 'top':
			return 'mt-4'
		case 'bottom':
			return 'mb-4'
		case 'both':
			return 'my-4'
		default:
			return ''
	}
})
</script>
